export default __webpack_public_path__ + "static/media/benox-logo-white.379a4dd3.png";